var render = function render(){var _vm=this,_c=_vm._self._c;return _c('corner-ribbon',{class:_vm.isCarousel ? 'bg-orange carousel-corner-ribbon' : 'bg-orange corner-ribbon'},[_vm._v("\n  SOLD\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }